/* eslint-disable react/no-unused-prop-types */
// eslint-disable-next-line no-unused-vars
import { Component, createRef, h, render } from 'preact';
import PropTypes from 'prop-types';
import accessibleAutocomplete from 'accessible-autocomplete';

const { __ } = wp.i18n;

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
class Autocomplete extends Component {

	/**
	 *
	 * @param {*} props
	 */
	constructor( props ) {
		super( props );

		// Create a ref for the plugin to use.
		this.ref = createRef();
	}

	/**
	 *
	 */
	componentDidMount() {
		const { id, source } = this.props;

		// Bail if no ID is supplied.
		if ( !id ) {
			throw new Error( 'id is not defined' );
		}

		// Bail if no source is supplied.
		if ( !source ) {
			throw new Error( 'source is not defined' );
		}

		// Make sure we have a node to attach to.
		if ( this.ref.current ) {
			// Start the plugin.
			accessibleAutocomplete( {
				// Merge props.
				...this.props,
				// Use our ref in this component.
				element: this.ref.current,
			} );
		}
	}

	/**
	 * Render the component.
	 * @returns
	 */
	render() {
		const { id, label } = this.props;

		return (
			<div
				className="facet__autocomplete"
				onChange={( event ) => { event.stopPropagation(); }}
				onKeyDown={( event ) => { event.stopPropagation(); }}>
				<label className="small" htmlFor={id}>{label}</label>
				<div ref={this.ref} />
			</div>
		);
	}
}

// Defaults. Mostly from the plugin docs.
Autocomplete.defaultProps = {
	autoselect: false,
	cssNamespace: 'autocomplete',
	defaultValue: '',
	displayMenu: 'inline',
	minLength: 0,
	name: 'input-autocomplete',
	placeholder: '',
	onConfirm: () => {},
	confirmOnBlur: true,
	showNoOptionsFound: true,
	showAllValues: false,
	required: false,
	tNoResults: () => {
		return __( 'No results found', 'ms-research' );
	},
	tAssistiveHint: () => {
		return __(
			'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
			'ms-research'
		);
	},
	dropdownArrow: '',
};

Autocomplete.propTypes = {
	// Required options https://github.com/alphagov/accessible-autocomplete#required-options
	id: PropTypes.string.isRequired,
	source: PropTypes.oneOfType( [PropTypes.array, PropTypes.func] ).isRequired,

	// Other options https://github.com/alphagov/accessible-autocomplete#other-options
	autoselect: PropTypes.bool,
	cssNamespace: PropTypes.string,
	defaultValue: PropTypes.string,
	displayMenu: PropTypes.string,
	minLength: PropTypes.number,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	onConfirm: PropTypes.func,
	confirmOnBlur: PropTypes.bool,
	showNoOptionsFound: PropTypes.bool,
	showAllValues: PropTypes.bool,
	required: PropTypes.bool,
	tNoResults: PropTypes.func,
	tAssistiveHint: PropTypes.func,
	dropdownArrow: PropTypes.string,

	// Custom component options
	label: PropTypes.string.isRequired,
};

export default Autocomplete;
